<template>
  <div id="L2" class="sub">
    <div class="wrapper">
      <kg-header :headerType=0 />
      <div id="content">
        <div class="inner_static">
          <h1 class="tit1">パスワードの再設定</h1>
          <div class="vm_wrap">
            <div class="inner_static">
              <p class="ins_lead type2">
                パスワードの再設定が<br>完了しました。
              </p>
            </div>
          </div>
          <div class="fixed_btn_area">
            <div class="inner_static">
              <a class="btn1" @click="btnLoginClick()">ログインする</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as App from '../../utils/App'
import {KG_STORAGE_KEY} from '../../constants/App'

// kagull Module
import Header from '../components/common/HomeIconHeader'

export default {
  components: {
    'kg-header': Header
  },
  methods: {
    btnLoginClick: function () {
      this.$router.push('/kagull/login')
    }
  },
  created: function () {
    App.removeLocalStorage(KG_STORAGE_KEY.PASSWORD_DATA)
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/pages/PasswordResetComplete.vue